<!-- =========================================================================================
    File Name: FormWizardNumberTab.vue
    Description: Form wizard with numbers in tabs
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vx-card>
		<div class="mt-3">
			<form-wizard
				color="rgba(var(--vs-primary), 1)"
				:title="null"
				:subtitle="null"
				:finishButtonText="TabContentTreeTitle"
				:backButtonText="$t('Resource.BackButton')"
				:nextButtonText="$t('Resource.Continue')"
				@on-change="handleChange"
				@on-complete="formSubmittedOpenConfirm"
				ref="formWizardRef"
			>
				<tab-content
					:title="tabContentOneTitle"
					class="mb-5"
					icon="feather icon-user"
					:before-change="validateStep1"
				>
					<!-- tab 1 content -->
					<div data-vv-scope="step-1">
						<resource-list
							v-if="resourceListMount"
							ref="ResourceList"
							:removeColumns="true"
							:relatedIds="[]"
							:customConfig="resourceListConfig"
							:openLoadFileForm="openLoadFileForm"
							:btnLoadFileForm="false"
							:maxSelectedRows="4"
						/>
					</div>
				</tab-content>

				<!-- tab 2 content -->
				<tab-content
					:title="$t('MassiveAssignment.SelectVisitPoints')"
					class="mb-5"
					icon="feather icon-map-pin"
					:before-change="validateStep2"
				>
					<!-- tab 1 content -->
					<div data-vv-scope="step-2">
						<visit-point-list
							v-if="VisitPointListMount"
							ref="VisitPointList"
							componentParent="VisitPointAssignedList"
							:customConfig="visitPointListConfig"
							:relatedIds="[]"
							:resource_id="null"
							:status_id="status_id"
						>
							<div>
								<vx-card
									ref="filterCard"
									:title="$t('Filters')"
									class="user-list-filters mb-8"
									no-shadow
									card-border
									collapse-action
								>
									<vs-row vs-w="12" class="mb-base">
										<vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
											<label class="vs-input--label">{{ $t("SearchBy") }}</label>
											<v-select
												v-model="searchField"
												:clearable="false"
												:options="searchOptions"
												v-validate="'required'"
												name="country"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
										</vs-col>
										<vs-col
											v-if="searchField.value === 'AdditionalFields'"
											vs-justify="center"
											vs-align="center"
											vs-lg="6"
											vs-sm="12"
											vs-xs="12"
										>
											<div class="vx-row">
												<div class="vx-col w-full md:w-2/3">
													<label class="vs-input--label">{{
														$t("VisitPointObject.Create.SelectObjectType")
													}}</label>
													<v-select
														v-model="additionalField"
														:clearable="false"
														:options="additionalOptions"
														v-validate="'required'"
														name="country"
														:dir="$vs.rtl ? 'rtl' : 'ltr'"
														value="typology_name"
														label="typology_name"
														class="w-full ml-2 mr-2"
													>
														<template v-slot:no-options="{search, searching}">
															<template v-if="searching">
																{{ $t("general.NoResultsFoundFor") + " "
																}}<em>{{ search }}</em>
															</template>
														</template>
													</v-select>
												</div>
												<div class="vx-col w-full md:w-1/3">
													<label class="vs-input--label">{{
														$t("Preferences.FindExactly")
													}}</label>
													<vs-switch class="mt-2" color="success" v-model="exact_values" />
												</div>
											</div>
										</vs-col>
										<vs-col
											v-else
											vs-justify="center"
											vs-align="center"
											vs-lg="6"
											vs-sm="12"
											vs-xs="12"
										>
											<!-- SEARCH -->
											<div class="mt-6">
												<vs-input
													:placeholder="$t('Search')"
													v-model="searchQuery"
													@keyup.enter="searchHandle"
													class="w-full ml-2 mr-2"
												/>
											</div>
										</vs-col>
									</vs-row>
									<dinamic-fields
										v-if="additionalField"
										ref="DinamicFields"
										:additionalFields="model"
										:additionalInfo="additional_info"
										:category="additionalField"
										:renderImgFileInput="false"
									></dinamic-fields>
									<div class="flex flex-wrap justify-end mt-6 mb-2 ml-2">
										<vs-button
											:title="$t('Search')"
											class="ml-2"
											type="border"
											icon-pack="feather"
											icon="icon-search"
											@click="searchHandle"
											>{{ $t("Search") }}
										</vs-button>
										<vs-button
											:title="$t('Schedule.Refresh')"
											class="ml-2"
											type="border"
											icon-pack="feather"
											icon="icon-refresh-cw"
											@click="refres"
											>{{ $t("Schedule.Refresh") }}
										</vs-button>
										<vs-button
											:title="$t('MassiveAssignment.LoadMassiveAssignmentUploadFile')"
											class="ml-2"
											type="border"
											icon-pack="feather"
											icon="icon-upload"
											@click="openLoadFileForm('visitPoints')"
										></vs-button>
									</div>
								</vx-card>
							</div>
						</visit-point-list>
					</div>
				</tab-content>
				<!-- tab 3 content -->
				<tab-content :title="TabContentTreeTitle" class="mb-5" icon="feather icon-save">
					<div class="vx-row">
						<div class="vx-col md:w-1/3 w-full md:mt-8">
							<massive-assignment-resume-resource-list
								:title="$t('MassiveAssignment.SelectedResources')"
								:subtitle="`Total ${getCheckedResources.length}`"
							></massive-assignment-resume-resource-list>
						</div>

						<div class="vx-col md:w-2/3 w-full md:mt-8">
							<massive-assignment-resume-visit-point-list
								:title="$t('MassiveAssignment.SelectedVisitPoints')"
								:subtitle="`Total ${getCheckedVisitPoints.length}`"
								:visitPointList="getCheckedVisitPoints"
							></massive-assignment-resume-visit-point-list>
						</div>
					</div>
				</tab-content>
			</form-wizard>
		</div>

		<vs-popup
			:fullscreen="false"
			:title="$t('MassiveAssignment.LoadMassiveAssignmentUploadFile')"
			:active.sync="loadFileFormActive"
			class="vs-popup--content-custom"
		>
			<MassiveAssignmentLoadFile
				ref="UploadFileForm"
				@uploadStatusEmit="uploadStatusEmit"
				@uploadCancelEmit="uploadCancelEmit"
				:fileType="fileType"
			/>
		</vs-popup>

		<vs-prompt
			:title="$t('MassiveAssignment.MassiveAssignment')"
			@cancel="() => {}"
			@accept="save_changes"
			@close="() => {}"
			:active.sync="submitConfirmActive"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div>
				<!--  <p>{{ $t("MassiveAssignment.VisitPointsConfirmAssign") }}</p> -->

				<div class="">
					<span>{{ $t("MassiveAssignment.ConfirmAssignText") }}</span>
					<div class="flex mt-4">
						<vs-checkbox v-model="checkboxSaveConfirm">{{ $t("Save") }}</vs-checkbox>
					</div>
				</div>

				<vs-input
					v-if="checkboxSaveConfirm"
					v-model="fileName"
					:label="$t('EnterFileName')"
					class="w-full mt-5"
				/>
			</div>
		</vs-prompt>
	</vx-card>
</template>

<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";

// Components
import ResourceList from "@/components/resource/user-list/ResourceList.vue";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import ResourceAssignedList from "@/components/resource/user-list/ResourceAssignedList.vue";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList.vue";
import MassiveAssignmentResumeResourceList from "./MassiveAssignmentResumeResourceList.vue";
import MassiveAssignmentResumeVisitPointList from "./MassiveAssignmentResumeVisitPointList.vue";
import MassiveAssignmentLoadFile from "./MassiveAssignmentLoadFile.vue";
// Store Module
import moduleResource from "@/store/resource/moduleResource.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import DinamicFields from "@/components/DinamicFields/DinamicFields";

export default {
	components: {
		DinamicFields,
		FormWizard,
		TabContent,
		vSelect,
		ResourceList,
		VisitPointList,
		ResourceAssignedList,
		VisitPointAssignedList,
		MassiveAssignmentResumeResourceList,
		MassiveAssignmentResumeVisitPointList,
		MassiveAssignmentLoadFile,
	},
	data() {
		return {
			//Config Resource List
			resourceListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: false,
				columns: [
					"id",
					"name",
					"lastname",
					"username",
					"email",
					"identification",
					"role_name",
					"alias",
					"status",
				],
				actionDropdown: false,
				btnAssigResources: false,
				popupMode: false,
				importMode: true,
				module: "massiveassignment",
			},
			//Config Visit Point List
			visitPointListConfig: {
				rowSelection: "multiple", // multiple | single
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: [
					"name",
					"identification",
					"address",
					"city",
					"typology_name",
					"status_name",
					"additional_info",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: true,
				showActions: false,
				cellRendererAdditionalFields: true,
			},
			firstName: "",
			lastName: "",
			email: "",
			city: "new-york",
			proposalTitle: "",
			jobTitle: "",
			textarea: "",
			fileName: "",
			eventLocation: "san-francisco",
			status: "json",
			cityOptions: [
				{text: "json", value: "json"},
				{text: "txt", value: "txt"},
				{text: "csv", value: "csv"},
			],
			resourceIds: [],
			visitPointsIds: [],
			searchQuery: "",
			searchField: {value: "Name", label: this.$t("Name")},
			dataSelect: [],
			additionalField: null,
			model: null,
			additional_info: {},
			checkboxResources: false,
			checkboxVisitPoints: false,
			checkboxSaveConfirm: false,
			status_id: [],
			resourceListMount: true,
			VisitPointListMount: true,
			loadFileFormActive: false,
			submitConfirmActive: false,
			fileType: "resources",
			exact_values: false,
		};
	},
	computed: {
		TabContentTreeTitle() {
			return `${this.$t("Save")} ${this.$t("And")} ${this.$t("VisitPointObject.Assig")}`;
		},
		getCheckedResources() {
			return this.$store.state.moduleResource.checkedResources;
		},
		getCheckedResourcesTotal() {
			return this.$store.state.moduleResource.checkedResources.length;
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		additionalOptions() {
			return this.dataSelect.category;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{
					value: "AdditionalFields",
					label: this.$t("Object.AdditionalFields"),
				},
			];
		},
		tabContentOneTitle() {
			return this.$t("MassiveAssignment.SelectResources") + " " + this.getCheckedResourcesTotal + "/" + "4";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		validateStep1() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-1").then((result) => {
					if (result && this.getCheckedResources.length > 0 && this.getCheckedResources.length <= 4) {
						resolve(true);
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MassiveAssignment.SelectResources"),
							text: this.$t("MassiveAssignment.MaxSelectedResources"),
							time: 5000,
						});
						reject(this.$t("MassiveAssignment.MaxSelectedResources"));
					}
				});
			});
		},
		validateStep2() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-2").then((result) => {
					if (result && this.getCheckedVisitPoints.length > 0) {
						resolve(true);
					} else {
						this.$vs.notify({
							color: "danger",
							title: this.$t("MassiveAssignment.SelectVisitPoints"),
							text: this.$t("MassiveAssignment.MaxSelectedVisitPoints"),
						});
						reject(this.$t("Resource.CorrectAllValues"));
					}
				});
			});
		},
		formSubmittedOpenConfirm() {
			this.submitConfirmActive = true;
		},
		save_changes() {
			if (this.checkboxSaveConfirm) {
				this.saveData();
			}
			const newVPIds = this.getCheckedVisitPoints.map((vp) => vp.id);
			// Crear array de promesas con cada recursos seleccionado
			const promises = this.getCheckedResources.map((resource) => {
				const resUp = Object.assign({}, resource);
				const currentVPIds = resource.visit_point_id;
				const visit_point_id = Array.from(new Set(newVPIds.concat(currentVPIds)));
				// Filtramos cualquier valor que no sea numero
				resUp.visit_point_id = visit_point_id.filter(Number);
				return this.$store.dispatch("moduleResource/updateResource", resUp);
			});

			this.openLoading();
			// Ejecutar todas las promesas de envios de mensajes
			Promise.allSettled(promises)
				.then((values) => {
					if (values.length > 0) {
						this.closeLoading();
						this.$vs.notify({
							color: "success",
							title: this.$t("MassiveAssignment.MassiveAssignment"),
							text: this.$t("MassiveAssignment.VisitPointsAssignationSuccessText"),
						});
						// Borramos las selcciones del estado global de la aplicacion
						this.$store.commit("moduleResource/SET_SELECTED_RESOURCE_PAGES", []);
						this.$store.dispatch("moduleVisitPoint/setSelectedVisitPoint", []);
						this.$store.commit("moduleVisitPoint/CLEAR_DEL_VISIT_POINT_CHECKED");
						this.$router.push("/apps/resource/resource-list");
						//this.$refs.formWizardRef.reset();
					}
				})
				.catch((error) => {
					this.closeLoading();
					this.$vs.notify({
						color: "danger",
						title: this.$t("MassiveAssignment.MassiveAssignment"),
						text: `${this.$t("ErrorMessage")}: ${error.message}`,
					});
				});
		},
		handleChange(prevIndex, nextIndex) {},
		async getAdditionalFields() {
			this.openLoading();
			const payload = {
				role: [],
				status: [],
				category: "VISIT_POINT",
				typology: [],
			};
			try {
				const response = await this.$store.dispatch(
					"moduleCommon/fetchDataRoleStatusCategoryTypology",
					payload
				);

				if (response.status !== 200) {
					return this.handleError(response.status);
				}
				this.dataSelect = response.data;
				this.status_id = this.dataSelect.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
				this.closeLoading();
			} catch (err) {
				this.closeLoading();
				this.throwSpecificError(err);
			}
		},
		refres() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = "";
			this.searchField = {value: "Name", label: this.$t("Name")};

			this.dataSelect = [];
			this.additionalField = null;
			(this.model = null), (this.additional_info = {});
		},
		searchHandle() {
			if (this.$refs.DinamicFields !== undefined && this.searchField.value === "AdditionalFields") {
				// recuperamos todas las propiedades adicionales modificadas desde el componente hijo
				const additional_info = this.$refs.DinamicFields.getAddionalInfo();
				// Formato para buscar por campos adicionales [['property_name', 'property_value']]
				const formatData = Object.entries(additional_info);
				this.$refs.VisitPointList.searchByAdditionalFields(
					[this.additionalField.typology_id],
					formatData,
					1,
					this.exact_values
				);
				return;
			}
			this.$refs.VisitPointList.searchResource2(this.searchField.value, this.searchQuery.trim(), 1);
		},
		saveData() {
			const a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";

			const data = {
				resources: this.checkboxSaveConfirm ? this.getCheckedResources : [],
				visitPoints: this.checkboxSaveConfirm ? this.getCheckedVisitPoints : [],
			};
			const fileName = this.fileName || new Date().getTime();
			const json = JSON.stringify(data),
				blob = new Blob([json], {type: "octet/stream"}),
				url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = fileName + ".json";
			a.click();
			window.URL.revokeObjectURL(url);
		},
		uploadStatusEmit(val) {
			if (this.fileType === "resources") {
				this.$refs.ResourceList.getResources();
			}
			if (this.fileType === "visitPoints") {
				this.$refs.VisitPointList.getVisitPoint(1);
			}
			this.$refs.formWizardRef.activateAll();
			this.loadFileFormActive = false;
		},
		uploadCancelEmit() {
			this.$refs.formWizardRef.reset();
			this.loadFileFormActive = false;
		},
		openLoadFileForm(val) {
			this.fileType = val;
			this.loadFileFormActive = true;
		},
	},
	watch: {
		searchField(val) {
			if (val.value !== "AdditionalFields") {
				this.additionalField = null;
				this.additional_info = {};
				return;
			}
		},
		additionalField(obj) {
			if (!obj) {
				return;
			}
			this.additional_info = {};
			// this.payloadResource.typology_id = obj.value;
			let dataFields = obj.json_properties;
			dataFields = dataFields.filter((element) => element.name !== "additional_info");
			const updateData = dataFields.map((element) => {
				return {...element, error: false};
			});
			this.model = [...updateData.filter(({additional}) => additional)];
		},
		getCheckedResourcesTotal(val) {
			if (val >= 4) {
				this.$vs.notify({
					color: "success",
					title: this.$t("MassiveAssignment.SelectResources"),
					text: this.$t("MassiveAssignment.MaxSelectedResourcesReached"),
					time: 5000,
				});
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		this.getAdditionalFields();
		this.exact_values = this.$store.state.modulePreferences.filter_exact_values;
	},
};
</script>
